document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.element-native').forEach(
  /**
   * @param {HTMLBaseElement} native
   */
  (native) => {
    const images = native.querySelectorAll('.images li');
    const targets = native.querySelectorAll('.hovers li');

    targets.forEach(
      /**
       * @param {HTMLBaseElement} hover
       * @param {number} index
       */
    (hover, index) => {
      hover.addEventListener('mouseenter', () => {
        images.forEach(
        /**
         * @param {HTMLBaseElement} image
         */
        (image) => image.classList.remove('active'));
        images.item(index).classList.add('active');
      });
    });
  });
});
